<app-role-view-dialog></app-role-view-dialog>
<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [buildParams]="buildParams"
>
</app-ag-grid-table>